// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "robotreservation/v1/robot_reservation.proto" (package "robotreservation.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Viam rover rentals
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../google/protobuf/struct";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf message robotreservation.v1.StateProgress
 */
export interface StateProgress {
    /**
     * @generated from protobuf field: string state = 1;
     */
    state: string;
    /**
     * @generated from protobuf field: bool done = 2;
     */
    done: boolean;
}
/**
 * @generated from protobuf message robotreservation.v1.RobotReservation
 */
export interface RobotReservation {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string user_email = 2;
     */
    userEmail: string;
    /**
     * @generated from protobuf field: string org_id = 3;
     */
    orgId: string;
    /**
     * @generated from protobuf field: string location_id = 4;
     */
    locationId: string;
    /**
     * @generated from protobuf field: string part_id = 5;
     */
    partId: string;
    /**
     * @generated from protobuf field: int32 priority = 6;
     */
    priority: number;
    /**
     * @generated from protobuf field: string reservation_state = 7;
     */
    reservationState: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 8;
     */
    createdOn?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp estimated_reservation_time = 9;
     */
    estimatedReservationTime?: Timestamp;
    /**
     * @generated from protobuf field: int32 estimated_seconds_until_reservation = 10;
     */
    estimatedSecondsUntilReservation: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end_time = 11;
     */
    endTime?: Timestamp; // when the reservation ends.
    /**
     * @generated from protobuf field: optional string error_message = 12;
     */
    errorMessage?: string;
    /**
     * @generated from protobuf field: bool allowed_to_extend = 13;
     */
    allowedToExtend: boolean;
    /**
     * @generated from protobuf field: bool allowed_to_cancel = 14;
     */
    allowedToCancel: boolean;
    /**
     * @generated from protobuf field: string robot_control_url = 15;
     */
    robotControlUrl: string;
    /**
     * @generated from protobuf field: int64 seconds_remaining = 16;
     */
    secondsRemaining: string;
    /**
     * @generated from protobuf field: bool allowed_to_set_priority = 17;
     */
    allowedToSetPriority: boolean;
    /**
     * @generated from protobuf field: string robot_name = 18;
     */
    robotName: string;
    /**
     * @generated from protobuf field: bool was_canceled = 19;
     */
    wasCanceled: boolean;
    /**
     * @generated from protobuf field: string robot_id = 20;
     */
    robotId: string;
    /**
     * @generated from protobuf field: string rover_type = 21;
     */
    roverType: string;
}
/**
 * @generated from protobuf message robotreservation.v1.CreateRobotReservationRequest
 */
export interface CreateRobotReservationRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * @generated from protobuf field: optional string location_id = 2;
     */
    locationId?: string;
    /**
     * @generated from protobuf field: optional string robot_id = 3;
     */
    robotId?: string;
    /**
     * @generated from protobuf field: optional string part_id = 4;
     */
    partId?: string;
    /**
     * @generated from protobuf field: optional int32 priority = 5;
     */
    priority?: number;
    /**
     * @generated from protobuf field: optional string reservation_state = 6;
     */
    reservationState?: string;
    /**
     * @generated from protobuf field: optional string robot_name = 7;
     */
    robotName?: string;
    /**
     * @generated from protobuf field: optional bool reset_config = 8;
     */
    resetConfig?: boolean;
    /**
     * @generated from protobuf field: optional string required_agent_id = 9;
     */
    requiredAgentId?: string;
}
/**
 * @generated from protobuf message robotreservation.v1.CreateRobotReservationResponse
 */
export interface CreateRobotReservationResponse {
    /**
     * @generated from protobuf field: robotreservation.v1.RobotReservation reservation = 1;
     */
    reservation?: RobotReservation;
}
/**
 * @generated from protobuf message robotreservation.v1.DeleteRobotReservationRequest
 */
export interface DeleteRobotReservationRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message robotreservation.v1.DeleteRobotReservationResponse
 */
export interface DeleteRobotReservationResponse {
}
/**
 * @generated from protobuf message robotreservation.v1.ListRobotReservationsRequest
 */
export interface ListRobotReservationsRequest {
}
/**
 * @generated from protobuf message robotreservation.v1.ListRobotReservationsResponse
 */
export interface ListRobotReservationsResponse {
    /**
     * @generated from protobuf field: repeated robotreservation.v1.RobotReservation reservations = 1;
     */
    reservations: RobotReservation[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp estimated_next_reservation_time = 2;
     */
    estimatedNextReservationTime?: Timestamp;
    /**
     * @generated from protobuf field: int32 estimated_seconds_until_next_reservation = 3;
     */
    estimatedSecondsUntilNextReservation: number;
}
/**
 * @generated from protobuf message robotreservation.v1.GetRobotReservationRequest
 */
export interface GetRobotReservationRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message robotreservation.v1.GetRobotReservationResponse
 */
export interface GetRobotReservationResponse {
    /**
     * @generated from protobuf field: robotreservation.v1.RobotReservation reservation = 1;
     */
    reservation?: RobotReservation;
}
/**
 * @generated from protobuf message robotreservation.v1.ExtendRobotReservationRequest
 */
export interface ExtendRobotReservationRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message robotreservation.v1.ExtendRobotReservationResponse
 */
export interface ExtendRobotReservationResponse {
    /**
     * @generated from protobuf field: robotreservation.v1.RobotReservation reservation = 1;
     */
    reservation?: RobotReservation;
}
/**
 * @generated from protobuf message robotreservation.v1.UpdateRobotReservationPriorityRequest
 */
export interface UpdateRobotReservationPriorityRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: int32 priority = 2;
     */
    priority: number;
}
/**
 * @generated from protobuf message robotreservation.v1.UpdateRobotReservationPriorityResponse
 */
export interface UpdateRobotReservationPriorityResponse {
    /**
     * @generated from protobuf field: robotreservation.v1.RobotReservation reservation = 1;
     */
    reservation?: RobotReservation;
}
/**
 * @generated from protobuf message robotreservation.v1.RoverAgent
 */
export interface RoverAgent {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string secret = 2;
     */
    secret: string;
    /**
     * @generated from protobuf field: string type = 3;
     */
    type: string;
    /**
     * @generated from protobuf field: string name = 4;
     */
    name: string;
}
/**
 * @generated from protobuf message robotreservation.v1.CreateRoverAgentRequest
 */
export interface CreateRoverAgentRequest {
    /**
     * @generated from protobuf field: string type = 1;
     */
    type: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message robotreservation.v1.CreateRoverAgentResponse
 */
export interface CreateRoverAgentResponse {
    /**
     * @generated from protobuf field: robotreservation.v1.RoverAgent agent = 1;
     */
    agent?: RoverAgent;
}
/**
 * @generated from protobuf message robotreservation.v1.DeleteRoverAgentRequest
 */
export interface DeleteRoverAgentRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message robotreservation.v1.DeleteRoverAgentResponse
 */
export interface DeleteRoverAgentResponse {
}
/**
 * @generated from protobuf message robotreservation.v1.ListRoverAgentsRequest
 */
export interface ListRoverAgentsRequest {
}
/**
 * @generated from protobuf message robotreservation.v1.ListRoverAgentsResponse
 */
export interface ListRoverAgentsResponse {
    /**
     * @generated from protobuf field: repeated robotreservation.v1.RoverAgent processors = 1;
     */
    processors: RoverAgent[];
    /**
     * @generated from protobuf field: repeated string allowed_agent_types = 2;
     */
    allowedAgentTypes: string[];
}
/**
 * @generated from protobuf message robotreservation.v1.TryProcessRequest
 */
export interface TryProcessRequest {
    /**
     * @generated from protobuf field: optional string current_item = 1;
     */
    currentItem?: string;
    /**
     * @generated from protobuf field: optional string current_state = 2;
     */
    currentState?: string;
    /**
     * @generated from protobuf field: optional string agent_id = 3;
     */
    agentId?: string;
}
/**
 * @generated from protobuf message robotreservation.v1.TryProcessResponse
 */
export interface TryProcessResponse {
    /**
     * @generated from protobuf field: bool queue_empty = 1;
     */
    queueEmpty: boolean;
    /**
     * @generated from protobuf field: optional robotreservation.v1.TryProcessResponse.Item item_to_process = 2;
     */
    itemToProcess?: TryProcessResponse_Item;
    /**
     * json string of the robot config to write.
     *
     * @generated from protobuf field: optional string robot_config = 3;
     */
    robotConfig?: string;
}
/**
 * @generated from protobuf message robotreservation.v1.TryProcessResponse.Item
 */
export interface TryProcessResponse_Item {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string state = 2;
     */
    state: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deadline = 3;
     */
    deadline?: Timestamp;
    /**
     * @generated from protobuf field: int64 cas = 4;
     */
    cas: string;
}
/**
 * @generated from protobuf message robotreservation.v1.UpdateProcessStateRequest
 */
export interface UpdateProcessStateRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string event = 2;
     */
    event: string;
    /**
     * @generated from protobuf field: int64 cas = 3;
     */
    cas: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct event_data = 4;
     */
    eventData?: Struct;
}
/**
 * @generated from protobuf message robotreservation.v1.UpdateProcessStateResponse
 */
export interface UpdateProcessStateResponse {
}
/**
 * @generated from protobuf message robotreservation.v1.GetReservationCountsRequest
 */
export interface GetReservationCountsRequest {
}
/**
 * @generated from protobuf message robotreservation.v1.GetReservationCountsResponse
 */
export interface GetReservationCountsResponse {
    /**
     * @generated from protobuf field: int32 queued = 1;
     */
    queued: number;
    /**
     * @generated from protobuf field: int32 running = 2;
     */
    running: number;
    /**
     * @generated from protobuf field: int32 finished_past_day = 3;
     */
    finishedPastDay: number;
    /**
     * @generated from protobuf field: int32 failed_past_day = 4;
     */
    failedPastDay: number;
}
/**
 * @generated from protobuf message robotreservation.v1.ListAllRobotReservationsRequest
 */
export interface ListAllRobotReservationsRequest {
    /**
     * @generated from protobuf field: optional string user_email = 1;
     */
    userEmail?: string;
    /**
     * @generated from protobuf field: optional int32 priority = 5;
     */
    priority?: number;
    /**
     * @generated from protobuf field: optional string reservation_state = 6;
     */
    reservationState?: string;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp created_on_or_greater = 7;
     */
    createdOnOrGreater?: Timestamp; // reservation created on or after this time.
    /**
     * @generated from protobuf field: optional int32 limit = 8;
     */
    limit?: number; // size to return
    /**
     * @generated from protobuf field: optional bool only_running = 9;
     */
    onlyRunning?: boolean;
    /**
     * @generated from protobuf field: optional bool only_failed = 10;
     */
    onlyFailed?: boolean;
    /**
     * @generated from protobuf field: optional bool use_queue_sort = 11;
     */
    useQueueSort?: boolean;
}
/**
 * @generated from protobuf message robotreservation.v1.ListAllRobotReservationsResponse
 */
export interface ListAllRobotReservationsResponse {
    /**
     * @generated from protobuf field: repeated robotreservation.v1.RobotReservation reservations = 1;
     */
    reservations: RobotReservation[];
    /**
     * @generated from protobuf field: google.protobuf.Timestamp estimated_next_reservation_time = 2;
     */
    estimatedNextReservationTime?: Timestamp;
    /**
     * @generated from protobuf field: int32 estimated_seconds_until_next_reservation = 3;
     */
    estimatedSecondsUntilNextReservation: number;
}
/**
 * @generated from protobuf message robotreservation.v1.GetActiveRobotReservationRequest
 */
export interface GetActiveRobotReservationRequest {
}
/**
 * @generated from protobuf message robotreservation.v1.GetActiveRobotReservationResponse
 */
export interface GetActiveRobotReservationResponse {
    /**
     * @generated from protobuf field: robotreservation.v1.RobotReservation reservation = 1;
     */
    reservation?: RobotReservation;
}
// @generated message type with reflection information, may provide speed optimized methods
class StateProgress$Type extends MessageType<StateProgress> {
    constructor() {
        super("robotreservation.v1.StateProgress", [
            { no: 1, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "done", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.StateProgress
 */
export const StateProgress = new StateProgress$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RobotReservation$Type extends MessageType<RobotReservation> {
    constructor() {
        super("robotreservation.v1.RobotReservation", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "location_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "priority", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "reservation_state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "created_on", kind: "message", T: () => Timestamp },
            { no: 9, name: "estimated_reservation_time", kind: "message", T: () => Timestamp },
            { no: 10, name: "estimated_seconds_until_reservation", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 12, name: "error_message", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "allowed_to_extend", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "allowed_to_cancel", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "robot_control_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "seconds_remaining", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 17, name: "allowed_to_set_priority", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "robot_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "was_canceled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "robot_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "rover_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.RobotReservation
 */
export const RobotReservation = new RobotReservation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRobotReservationRequest$Type extends MessageType<CreateRobotReservationRequest> {
    constructor() {
        super("robotreservation.v1.CreateRobotReservationRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "location_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "robot_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "part_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "priority", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "reservation_state", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "robot_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "reset_config", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "required_agent_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.CreateRobotReservationRequest
 */
export const CreateRobotReservationRequest = new CreateRobotReservationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRobotReservationResponse$Type extends MessageType<CreateRobotReservationResponse> {
    constructor() {
        super("robotreservation.v1.CreateRobotReservationResponse", [
            { no: 1, name: "reservation", kind: "message", T: () => RobotReservation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.CreateRobotReservationResponse
 */
export const CreateRobotReservationResponse = new CreateRobotReservationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRobotReservationRequest$Type extends MessageType<DeleteRobotReservationRequest> {
    constructor() {
        super("robotreservation.v1.DeleteRobotReservationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.DeleteRobotReservationRequest
 */
export const DeleteRobotReservationRequest = new DeleteRobotReservationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRobotReservationResponse$Type extends MessageType<DeleteRobotReservationResponse> {
    constructor() {
        super("robotreservation.v1.DeleteRobotReservationResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.DeleteRobotReservationResponse
 */
export const DeleteRobotReservationResponse = new DeleteRobotReservationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRobotReservationsRequest$Type extends MessageType<ListRobotReservationsRequest> {
    constructor() {
        super("robotreservation.v1.ListRobotReservationsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.ListRobotReservationsRequest
 */
export const ListRobotReservationsRequest = new ListRobotReservationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRobotReservationsResponse$Type extends MessageType<ListRobotReservationsResponse> {
    constructor() {
        super("robotreservation.v1.ListRobotReservationsResponse", [
            { no: 1, name: "reservations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RobotReservation },
            { no: 2, name: "estimated_next_reservation_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "estimated_seconds_until_next_reservation", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.ListRobotReservationsResponse
 */
export const ListRobotReservationsResponse = new ListRobotReservationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotReservationRequest$Type extends MessageType<GetRobotReservationRequest> {
    constructor() {
        super("robotreservation.v1.GetRobotReservationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.GetRobotReservationRequest
 */
export const GetRobotReservationRequest = new GetRobotReservationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRobotReservationResponse$Type extends MessageType<GetRobotReservationResponse> {
    constructor() {
        super("robotreservation.v1.GetRobotReservationResponse", [
            { no: 1, name: "reservation", kind: "message", T: () => RobotReservation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.GetRobotReservationResponse
 */
export const GetRobotReservationResponse = new GetRobotReservationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExtendRobotReservationRequest$Type extends MessageType<ExtendRobotReservationRequest> {
    constructor() {
        super("robotreservation.v1.ExtendRobotReservationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.ExtendRobotReservationRequest
 */
export const ExtendRobotReservationRequest = new ExtendRobotReservationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExtendRobotReservationResponse$Type extends MessageType<ExtendRobotReservationResponse> {
    constructor() {
        super("robotreservation.v1.ExtendRobotReservationResponse", [
            { no: 1, name: "reservation", kind: "message", T: () => RobotReservation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.ExtendRobotReservationResponse
 */
export const ExtendRobotReservationResponse = new ExtendRobotReservationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRobotReservationPriorityRequest$Type extends MessageType<UpdateRobotReservationPriorityRequest> {
    constructor() {
        super("robotreservation.v1.UpdateRobotReservationPriorityRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "priority", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.UpdateRobotReservationPriorityRequest
 */
export const UpdateRobotReservationPriorityRequest = new UpdateRobotReservationPriorityRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRobotReservationPriorityResponse$Type extends MessageType<UpdateRobotReservationPriorityResponse> {
    constructor() {
        super("robotreservation.v1.UpdateRobotReservationPriorityResponse", [
            { no: 1, name: "reservation", kind: "message", T: () => RobotReservation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.UpdateRobotReservationPriorityResponse
 */
export const UpdateRobotReservationPriorityResponse = new UpdateRobotReservationPriorityResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RoverAgent$Type extends MessageType<RoverAgent> {
    constructor() {
        super("robotreservation.v1.RoverAgent", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.RoverAgent
 */
export const RoverAgent = new RoverAgent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRoverAgentRequest$Type extends MessageType<CreateRoverAgentRequest> {
    constructor() {
        super("robotreservation.v1.CreateRoverAgentRequest", [
            { no: 1, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.CreateRoverAgentRequest
 */
export const CreateRoverAgentRequest = new CreateRoverAgentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRoverAgentResponse$Type extends MessageType<CreateRoverAgentResponse> {
    constructor() {
        super("robotreservation.v1.CreateRoverAgentResponse", [
            { no: 1, name: "agent", kind: "message", T: () => RoverAgent }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.CreateRoverAgentResponse
 */
export const CreateRoverAgentResponse = new CreateRoverAgentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRoverAgentRequest$Type extends MessageType<DeleteRoverAgentRequest> {
    constructor() {
        super("robotreservation.v1.DeleteRoverAgentRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.DeleteRoverAgentRequest
 */
export const DeleteRoverAgentRequest = new DeleteRoverAgentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRoverAgentResponse$Type extends MessageType<DeleteRoverAgentResponse> {
    constructor() {
        super("robotreservation.v1.DeleteRoverAgentResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.DeleteRoverAgentResponse
 */
export const DeleteRoverAgentResponse = new DeleteRoverAgentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRoverAgentsRequest$Type extends MessageType<ListRoverAgentsRequest> {
    constructor() {
        super("robotreservation.v1.ListRoverAgentsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.ListRoverAgentsRequest
 */
export const ListRoverAgentsRequest = new ListRoverAgentsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRoverAgentsResponse$Type extends MessageType<ListRoverAgentsResponse> {
    constructor() {
        super("robotreservation.v1.ListRoverAgentsResponse", [
            { no: 1, name: "processors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RoverAgent },
            { no: 2, name: "allowed_agent_types", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.ListRoverAgentsResponse
 */
export const ListRoverAgentsResponse = new ListRoverAgentsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TryProcessRequest$Type extends MessageType<TryProcessRequest> {
    constructor() {
        super("robotreservation.v1.TryProcessRequest", [
            { no: 1, name: "current_item", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "current_state", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "agent_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.TryProcessRequest
 */
export const TryProcessRequest = new TryProcessRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TryProcessResponse$Type extends MessageType<TryProcessResponse> {
    constructor() {
        super("robotreservation.v1.TryProcessResponse", [
            { no: 1, name: "queue_empty", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "item_to_process", kind: "message", T: () => TryProcessResponse_Item },
            { no: 3, name: "robot_config", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.TryProcessResponse
 */
export const TryProcessResponse = new TryProcessResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TryProcessResponse_Item$Type extends MessageType<TryProcessResponse_Item> {
    constructor() {
        super("robotreservation.v1.TryProcessResponse.Item", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "deadline", kind: "message", T: () => Timestamp },
            { no: 4, name: "cas", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.TryProcessResponse.Item
 */
export const TryProcessResponse_Item = new TryProcessResponse_Item$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateProcessStateRequest$Type extends MessageType<UpdateProcessStateRequest> {
    constructor() {
        super("robotreservation.v1.UpdateProcessStateRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "event", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "cas", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "event_data", kind: "message", T: () => Struct }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.UpdateProcessStateRequest
 */
export const UpdateProcessStateRequest = new UpdateProcessStateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateProcessStateResponse$Type extends MessageType<UpdateProcessStateResponse> {
    constructor() {
        super("robotreservation.v1.UpdateProcessStateResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.UpdateProcessStateResponse
 */
export const UpdateProcessStateResponse = new UpdateProcessStateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReservationCountsRequest$Type extends MessageType<GetReservationCountsRequest> {
    constructor() {
        super("robotreservation.v1.GetReservationCountsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.GetReservationCountsRequest
 */
export const GetReservationCountsRequest = new GetReservationCountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReservationCountsResponse$Type extends MessageType<GetReservationCountsResponse> {
    constructor() {
        super("robotreservation.v1.GetReservationCountsResponse", [
            { no: 1, name: "queued", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "running", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "finished_past_day", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "failed_past_day", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.GetReservationCountsResponse
 */
export const GetReservationCountsResponse = new GetReservationCountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAllRobotReservationsRequest$Type extends MessageType<ListAllRobotReservationsRequest> {
    constructor() {
        super("robotreservation.v1.ListAllRobotReservationsRequest", [
            { no: 1, name: "user_email", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "priority", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "reservation_state", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "created_on_or_greater", kind: "message", T: () => Timestamp },
            { no: 8, name: "limit", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "only_running", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "only_failed", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "use_queue_sort", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.ListAllRobotReservationsRequest
 */
export const ListAllRobotReservationsRequest = new ListAllRobotReservationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAllRobotReservationsResponse$Type extends MessageType<ListAllRobotReservationsResponse> {
    constructor() {
        super("robotreservation.v1.ListAllRobotReservationsResponse", [
            { no: 1, name: "reservations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RobotReservation },
            { no: 2, name: "estimated_next_reservation_time", kind: "message", T: () => Timestamp },
            { no: 3, name: "estimated_seconds_until_next_reservation", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.ListAllRobotReservationsResponse
 */
export const ListAllRobotReservationsResponse = new ListAllRobotReservationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetActiveRobotReservationRequest$Type extends MessageType<GetActiveRobotReservationRequest> {
    constructor() {
        super("robotreservation.v1.GetActiveRobotReservationRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.GetActiveRobotReservationRequest
 */
export const GetActiveRobotReservationRequest = new GetActiveRobotReservationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetActiveRobotReservationResponse$Type extends MessageType<GetActiveRobotReservationResponse> {
    constructor() {
        super("robotreservation.v1.GetActiveRobotReservationResponse", [
            { no: 1, name: "reservation", kind: "message", T: () => RobotReservation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message robotreservation.v1.GetActiveRobotReservationResponse
 */
export const GetActiveRobotReservationResponse = new GetActiveRobotReservationResponse$Type();
/**
 * @generated ServiceType for protobuf service robotreservation.v1.RobotReservationService
 */
export const RobotReservationService = new ServiceType("robotreservation.v1.RobotReservationService", [
    { name: "CreateRobotReservation", options: {}, I: CreateRobotReservationRequest, O: CreateRobotReservationResponse },
    { name: "DeleteRobotReservation", options: {}, I: DeleteRobotReservationRequest, O: DeleteRobotReservationResponse },
    { name: "ListRobotReservations", options: {}, I: ListRobotReservationsRequest, O: ListRobotReservationsResponse },
    { name: "GetRobotReservation", options: {}, I: GetRobotReservationRequest, O: GetRobotReservationResponse },
    { name: "ExtendRobotReservation", options: {}, I: ExtendRobotReservationRequest, O: ExtendRobotReservationResponse },
    { name: "UpdateRobotReservationPriority", options: {}, I: UpdateRobotReservationPriorityRequest, O: UpdateRobotReservationPriorityResponse },
    { name: "CreateRoverAgent", options: {}, I: CreateRoverAgentRequest, O: CreateRoverAgentResponse },
    { name: "DeleteRoverAgent", options: {}, I: DeleteRoverAgentRequest, O: DeleteRoverAgentResponse },
    { name: "ListRoverAgents", options: {}, I: ListRoverAgentsRequest, O: ListRoverAgentsResponse },
    { name: "TryProcess", options: {}, I: TryProcessRequest, O: TryProcessResponse },
    { name: "UpdateProcessState", options: {}, I: UpdateProcessStateRequest, O: UpdateProcessStateResponse },
    { name: "GetReservationCounts", options: {}, I: GetReservationCountsRequest, O: GetReservationCountsResponse },
    { name: "ListAllRobotReservations", options: {}, I: ListAllRobotReservationsRequest, O: ListAllRobotReservationsResponse },
    { name: "GetActiveRobotReservation", options: {}, I: GetActiveRobotReservationRequest, O: GetActiveRobotReservationResponse }
]);
